import moment from 'moment-timezone';

import { readingType } from './constants';

export const getIsButtonEnabled = (data, errors) => {
  if (
    !data.startDate ||
    !data.endDate ||
    !readingType.some((rt) => rt.value === data.readingType?.value) ||
    Object.values(errors).some((e) => e)
  )
    return false;

  return true;
};

export const validateData = (field, value, data) => {
  let errMsg = '';

  switch (field) {
    case 'startDate':
      if (value === undefined) {
        errMsg = 'Invalid date format';
      } else if (!value) {
        errMsg = 'Date should not be empty';
      } else if (value && moment(value).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
        errMsg = 'Date should not be in the future';
      } else if (value && moment(value).isAfter(data.endDate)) {
        errMsg = 'Start date should be before end date';
      }
      break;
    case 'endDate':
      if (value === undefined) {
        errMsg = 'Invalid date format';
      } else if (!value) {
        errMsg = 'Date should not be empty';
      } else if (value && moment(value).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
        errMsg = 'Date should not be in the future';
      } else if (value && moment(value).isBefore(data.startDate)) {
        errMsg = 'End date should be after start date';
      }
      break;
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};

export const getPayload = (data) => {
  const payload = {
    ...data,
    readingType: data.readingType?.value ?? null,
  };

  return payload;
};

export const generatePDFName = (data, patientId) => {
  const docTypes = data.readingType;
  let docType = '';

  switch (true) {
    case docTypes.BGM:
      docType = 'BGM';
      break;
    default:
      docType = 'CGM';
  }

  return `${patientId}_LMN_${docType}_${data.startDate.replace(/-/g, '')}_${data.endDate.replace(
    /-/g,
    '',
  )}__${moment().utc().format('YYYYMMDD')}`;
};
